import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useTrackActivatedIntercom } from "@air/analytics";
import { Check as CheckIcon } from "@air/next-icons";
import { Button } from "@air/primitive-button";
import { Modal, ModalCloseButton } from "@air/primitive-modal";
import { Routes } from "~/constants/routes";
export const enterpriseOptions = [
    "Custom storage & user limits",
    "180 day deletion recovery",
    "AI enrichment: OCR, image facial recognition, video chapters, smart tags & summaries",
    "Reporting, analytics, API and Zapier",
    "Dedicated onboarding, support Slack and CSM"
];
export const EnterprisePlanModal = (param)=>{
    let { onClose } = param;
    const { trackActivatedIntercom } = useTrackActivatedIntercom();
    const clickedContactSales = ()=>{
        trackActivatedIntercom({
            location: "enterprise-contact-sales"
        });
    };
    return /*#__PURE__*/ _jsx(Modal, {
        isOpen: true,
        className: "w-[320px]",
        onDismiss: onClose,
        children: /*#__PURE__*/ _jsxs(_Fragment, {
            children: [
                /*#__PURE__*/ _jsx("div", {
                    className: "flex items-center justify-end",
                    children: /*#__PURE__*/ _jsx(ModalCloseButton, {
                        className: "shrink-0",
                        onClick: onClose
                    })
                }),
                /*#__PURE__*/ _jsxs("div", {
                    className: "flex flex-col items-center gap-4",
                    children: [
                        /*#__PURE__*/ _jsx("p", {
                            className: "text-center text-24 font-semibold text-grey-12",
                            children: " Enterprise plan"
                        }),
                        /*#__PURE__*/ _jsx("p", {
                            className: "text-center text-12 text-grey-11",
                            children: "For medium to large teams with 20+ members"
                        }),
                        /*#__PURE__*/ _jsx("p", {
                            className: "text-center text-16 font-medium text-grey-12",
                            children: "Need to make changes?"
                        }),
                        /*#__PURE__*/ _jsx(Button, {
                            appearance: "outline",
                            asChild: true,
                            color: "blue",
                            size: "large",
                            onClick: clickedContactSales,
                            children: /*#__PURE__*/ _jsx("a", {
                                href: Routes.enterprise.expansion,
                                target: "_blank",
                                children: "Contact Us"
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ _jsxs("div", {
                    className: "my-10 flex flex-col gap-3",
                    children: [
                        /*#__PURE__*/ _jsx("p", {
                            className: "text-16 font-semibold text-grey-12",
                            children: "Your plan includes"
                        }),
                        /*#__PURE__*/ _jsx("div", {
                            className: "flex flex-col gap-3",
                            children: enterpriseOptions.map((option, index)=>/*#__PURE__*/ _jsxs("div", {
                                    className: "flex gap-2",
                                    children: [
                                        /*#__PURE__*/ _jsx(CheckIcon, {
                                            className: "w-4 text-teal-9"
                                        }),
                                        /*#__PURE__*/ _jsx("p", {
                                            className: "text-14 text-grey-11",
                                            children: option
                                        })
                                    ]
                                }, index))
                        })
                    ]
                })
            ]
        })
    });
};
